import script from "./ConstructorAtribut.vue?vue&type=script&setup=true&lang=js"
export * from "./ConstructorAtribut.vue?vue&type=script&setup=true&lang=js"

import "./ConstructorAtribut.vue?vue&type=style&index=0&id=2e7ab146&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e7ab146"]])

export default __exports__